import React from 'react';
import Icon from 'components/common/Icon';
// LIB
import PDFHelpers from 'lib/helpers/PDFHelpers';

const BackButton = ({ onBack }) => (
  <div style={{ textAlign: 'left' }}>
    <a size="large" style={{ margiRight: 10, fontSize: 14 }} onClick={() => onBack()}>
      <Icon type="left" style={{ marginRight: 3 }} />
        EDIT
    </a>
  </div>
);

class ReviewStep extends React.PureComponent {
  getInvoicePreview = () => {
    let { invoice, client } = this.props;
    // const invoice = this.getInvoice();
    let invoiceProps = PDFHelpers.getInvoiceProps({
      client,
      invoice: {
        ...invoice,
        due: invoice.finalPaymentDueDate,
      },
      organization: this.props.invoice.organization,
    });
    let invoiceHTML = PDFHelpers.getHtmlInvoice(invoiceProps);
    return { __html: invoiceHTML };
  };

  render() {
    const { onBack } = this.props;
    return (
      <div id="invoice-container" style={{ width: 700, margin: 'auto', maxWidth: '100%' }}>
        <BackButton onBack={onBack} />
        <div dangerouslySetInnerHTML={this.getInvoicePreview()} />
      </div>
    );
  }
}

export default ReviewStep;



// WEBPACK FOOTER //
// ./src/routes/invoice-create/ReviewStep/index.js